import { ElementRef, Renderer, OnInit } from '@angular/core';
import { MdbDropdownDirective, CtrRowItem } from './dropdown.directive';
var MdbRowDirective = /** @class */ (function () {
    function MdbRowDirective(el, renderer, dropdown) {
        this.el = el;
        this.renderer = renderer;
        this.dropdown = dropdown;
        this.selected = false;
    }
    MdbRowDirective.prototype.ngOnInit = function () {
        this.dropdown.registerRow(new CtrRowItem(this, this._rowIndex));
    };
    Object.defineProperty(MdbRowDirective.prototype, "mdbRow", {
        set: function (index) {
            this._rowIndex = index;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdbRowDirective.prototype, "dataItem", {
        set: function (item) {
            this._item = item;
        },
        enumerable: true,
        configurable: true
    });
    MdbRowDirective.prototype.onClick = function () {
        this.dropdown.onSelected(this._item);
    };
    MdbRowDirective.prototype.onMouseEnter = function () {
        this.dropdown.highlightRow(this._rowIndex);
    };
    MdbRowDirective.prototype.setHighlighted = function (selected) {
        this.selected = selected;
        this.renderer.setElementClass(this.el.nativeElement, 'completer-selected-row', this.selected);
    };
    MdbRowDirective.prototype.getNativeElement = function () {
        return this.el.nativeElement;
    };
    MdbRowDirective.prototype.getDataItem = function () {
        return this._item;
    };
    return MdbRowDirective;
}());
export { MdbRowDirective };



// WEBPACK FOOTER //
// ./node_modules/ng-mdb-pro/pro/autocomplete/directives/row.directive.ts.pre-build-optimizer.js